// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__15Mor","inner":"Footer_inner__2M-TH"};